export const CAMELOT_GRAVITY_ROUTER_CONTRACT_ADDRESS = '0x60A186019F81bFD04aFc16c9C01804a04E79e68B';
